import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=9bb7719e&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=ts"
export * from "./Tag.vue?vue&type=script&lang=ts"
import style0 from "./Tag.vue?vue&type=style&index=0&id=9bb7719e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb7719e",
  null
  
)

export default component.exports